<template>
  <div class="SmartSwitch">
    <p>{{ status | typeFilter }}</p>
    <div class="box">
      <div v-for="(item,index) in 3" :key="index"></div>
    </div>
    <div @click="change" class="box-value">
      <i :style="{color:type?'#fff':''}" class="iconfont icon-kaiguan1"></i>
    </div>
    <StarrySkyCanvas color="#94cdfb" :line="false" :has="9"/>
  </div>
</template>

<script>
import StarrySkyCanvas from "@/components/StarrySkyCanvas.vue";
export default {
  name: 'SmartSwitch',
  props: {
    status:{
      type: Boolean,
      default(){
        return false
      }
    }
  },
  data () {
    return {
      type: false
    }
  },
  components: {
    StarrySkyCanvas
  },
  mounted () {
    this.type = this.status;
  },
  methods: {
    change(){
      this.type = !this.type;
      this.$emit('change',this.type);
    }
  },
  filters: {
    typeFilter(val){
      if(val){
        return '开启状态';
      }else{
        return '关闭状态';
      }
    }
  },
  watch: {
    status(n,o){
      this.type = n;
    }
  }
}
</script>


<style lang="less" scoped>
@import url("../../../assets/less-css/flexible.less");
.SmartSwitch {
  background: #1c8df6;
  .h(680);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &>p{
    .fs(31);
    text-align: center;
    color: #fff;
    position: absolute;
    .t(82);
  }
  .box{
    .w(230);
    .h(230);
    position: relative;
    z-index: 100;
    div{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: solid 2px #2e99f7;
      border-radius:50%;
      box-sizing: border-box;
      transform: scale()
    }
    div:nth-child(1){
      animation: scale 3s infinite linear;
    }
    div:nth-child(2){
      animation: scale 3s 1s infinite linear;
    }
    div:nth-child(3){
      animation: scale 3s 2s infinite linear;
    }
  }
  .box-value{
    position: absolute;
    .w(233);
    .h(233);
    background-color: #359df7;
    border-radius: 50%;
    z-index: 200;
    box-shadow: 0 0 20px #2e86d3;
    text-align: center;
    .lh(233);
    .icon-kaiguan1{
      transition: all 0.3s;
      color: #83c2fa;
      .fs(119);
    }
  }
}

@keyframes scale {
  100%{
    .w(534);
    .h(534);
    .l(-152);
    .t(-152);
    opacity: 0;
  }
}
</style>
